import type { AssetConditionRatingTagProps } from "./asset-condition-rating-tag.type";

import { useReferentialConditionRatings } from "@/entities/referential/referential-condition-ratings";
import { Tag } from "@/ui/tag";

export const AssetConditionRatingTag = ({
  asset,
  ...tagProps
}: AssetConditionRatingTagProps) => {
  const { getConditionRating, notRated } = useReferentialConditionRatings();

  const conditionRating =
    getConditionRating(asset?.condition_rating) ?? notRated;

  if (!conditionRating) return null;

  return (
    <Tag {...tagProps} variant="solid" color={conditionRating.color}>
      {conditionRating.name}
    </Tag>
  );
};
